export default store => {
  store.subscribe(mutation => {
    if (mutation.type === 'business/SET_INFO') {
      const mutationPayload = mutation.payload;
      const { testDriveLocations, products } = mutationPayload;

      // Has test drive? Check for location options
      if (products.includes('testDrive')) {
        if (testDriveLocations.length > 1) {
          store.commit('testDrive/SET_TEST_DRIVE_APP_ROUTE', 'selectLocation', { root: true });
        } else if (testDriveLocations.length === 1) {
          store.commit('testDrive/SET_TEST_DRIVE_APP_ROUTE', testDriveLocations[0], { root: true });
          if (testDriveLocations[0] === 'home') {
            store.commit('testDrive/SET_CHOSEN_ROUTE', 'home', { root: true });
          }
        }
      }
    }
  });
};
